<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component({})
    export class OrderDestinationsMixin extends Vue {
        destinations = []
        destinationLocations = []

        async mounted() {
            if (this.$conf.public.account.orderDestinations) {
                const orderId = this.$route.params.id
                try {
                    this.destinations = (await this.$api.orderDestinations.get({orderId})).orderDestinations
                    const cityIds = this.destinations.reduce((cityIds, {cityId}) => {
                        if (!cityIds.includes(cityId)) cityIds.push(cityId)
                        return cityIds
                    }, [])
                    this.destinationLocations = (
                        await Promise.allSettled(
                            cityIds.map(async id => (await this.$api.locations.get({id, limitCities: 1})).cities[0])
                        )
                    ).map(({value}) => value)
                } catch (e) {
                    console.error(e)
                    this.destinations = []
                    this.destinationLocations = []
                }
            }
        }

        destinationLocation(destination) {
            return this.destinationLocations.find(({id}) => id === destination.cityId)
        }

        destinationServices(destination) {
            return this.nonPackageServices.filter(({serviceId}) => destination.serviceIds.includes(serviceId))
        }

        itineraryDestination(index) {
            const getItineraryDestinationIndex = index => {
                const itineraryServiceIds = (this.itineraryDays[index].services?.times || [])
                    .map(({service}) => service.map(({serviceId}) => serviceId))
                    .flat()
                return this.destinationsSortedByDate.findIndex(
                    ({serviceIds}) => itineraryServiceIds.filter(id => serviceIds.includes(id)).length > 0
                )
            }
            const itineraryDestinationIndex = getItineraryDestinationIndex(index)
            if (index > 0) {
                const prevItineraryDestinationIndex = getItineraryDestinationIndex(index - 1)
                if (itineraryDestinationIndex !== prevItineraryDestinationIndex) {
                    return this.destinationsSortedByDate[itineraryDestinationIndex]
                }
                return null
            } else if (itineraryDestinationIndex !== -1) {
                return this.destinationsSortedByDate[itineraryDestinationIndex]
            }
            return null
        }

        async removeDestination(destination) {
            try {
                await this.$api.orderDestinations.remove(destination.id)
                const index = this.destinations.findIndex(({id}) => id === destination.id)
                const indexDestinationLocation = this.destinationLocations.findIndex(
                    ({id}) => id === destination.cityId
                )
                this.destinations.splice(index, 1)
                this.destinationLocations.splice(indexDestinationLocation, 1)
            } catch (e) {
                this.$toast.error(this.$t('error'))
            }
        }

        get nonPackageServicesWithoutDestination() {
            return this.destinations.length
                ? this.nonPackageServices.filter(
                      service => !this.destinations.find(({serviceIds}) => serviceIds.includes(service.serviceId))
                  )
                : this.nonPackageServices
        }

        get destinationsSortedByDate() {
            return [...this.destinations].sort((a, b) => new Date(a.dateFrom) - new Date(b.dateFrom))
        }
    }

    export default OrderDestinationsMixin
</script>
